<template>
  <v-container>
    
    <v-dialog v-model="openModal" scrollable max-width="490" >
      <v-card>
        <v-card-title class="text-h5 lighten-2">{{ $t('add_status') }}</v-card-title>
        <v-card-text>

          <v-flex class="form-control" style="display: inherit;">
            <div class="input-icons">
              <input
                type="text"
                v-model="dataStatus.name"
                class="form-control"
                :placeholder="$t('enter_status_name')"
                style="margin-bottom: 10px"
              />
            </div>
          </v-flex>
          
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            color="primary"
            text
            @click="isAdd ? onPostUserStatus() : onPutUserStatus()"
          > {{ $t(`${isAdd ? 'Add' : 'Save'}`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout>
      <v-flex>
        <h1 class="primary--text">
          {{ $t('Status Management') }}
        </h1>
      </v-flex>
      <v-flex class="form-control" style="display: inherit;">
        <div class="input-icons">
          <i class="fa fa-search icon"></i>
          <input
            @keyup.enter="
              pageNumber = 1
              getUserStatus()
            "
            type="text"
            v-model="search"
            class="form-control"
            :placeholder="$t('Search Conversation Name')"
            style="margin-bottom: 10px"
          />
          <v-btn v-show="search.length > 0" @click="clearSearch" icon class="icon-close">
            <i class="fa fa-close"></i
          ></v-btn>
        </div>
        <v-btn
          @click="
            pageNumber = 1
            getUserStatus()
          "
          color="primary"
        >
          {{ $t('Search') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="text-xs-right text-sm-right mt-2">
    <v-btn color="primary" @click="openModal = !openModal; dataStatus={id:'',name:''}" outline>
      <i class="fa fa-plus mr-1"></i>
      {{ $t('Add') }}
    </v-btn>
    </div>
    <div class="text-xs-right text-sm-right mt-2">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="onClickPageinate"
      ></v-pagination>
    </div>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mt-3"
      :loading="loading"
      hide-actions
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-right">
            <v-btn color="primary" @click="onEdit(props.item)" fab small depressed>
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn @click="onDelete(props.item.id)" fab small depressed>
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-xs-right text-sm-right mt-2">
      <v-pagination
        v-model="pageNumber"
        :length="pageCount"
        @input="onClickPageinate"
        class="mb-2"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import api from '@/api'
import config from '@/config'
export default {
  data() {
    return {
      pageNumber: 1,
      size: 50,
      total_count: 0,
      search: '',
      headers: [
        {
          value: 'name',
          text: 'Name',
          align: 'center'
        },
        {
          text: '',
          sortable: false
        }
      ],
      items: [],
      loading: true,
      dataStatus:{id:'',name:''},
      openModal: false
    }
  },
  computed: {
    pageCount: function() {
      const vm = this
      let l = vm.total_count
      let s = vm.size
      return Math.ceil(l / s)
    },
    isAdd:function (){
      return this.dataStatus.id == ''
    }
  },
  async mounted() {
    await this.getUserStatus()
  },
  methods: {
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.getUserStatus()
    },
    onClickPageinate(pageNum) {
      const vm = this
      vm.pageNumber = pageNum
      $('html, body').animate({
        scrollTop: 0
      })

      vm.getUserStatus(pageNum)
    },
    async getUserStatus(page) {
      const vm = this
      vm.loading = true
      const response = await vm.get(
        `page/` +
          vm.$store.state.selectedBot.pageid +
          `/user-status-list?limit=${vm.size}&offset=${page * vm.size -
            vm.size}&sort=createdat_desc&filter_name=${vm.search}`
      )
      if (response.success) {
        vm.items = response.result
        vm.total_count = response.total_count
      }
      vm.loading = false
    },
    onPostUserStatus(){
      const vm = this
      vm.loading = true
      const url = `${config.serverUrl}page/${vm.$store.state.selectedBot.pageid}/user-status-list`
      axios.post(url,{"name": vm.dataStatus.name })
      .then((res)=>{
        if (res.data.success) {
          vm.pageNumber = 1
          vm.getUserStatus()
          vm.dataStatus={id:'',name:''}
          vm.openModal = false
          vm.$swal.fire({
            type: 'success',
            title: vm.$t('Success'),
            text: vm.$t('add_status_success')
          })
        }
      }).catch((err) => {
        console.error(err);
        vm.$swal.fire({
          type: 'error',
          title: vm.$t('Error'),
          text: vm.$t(`${err.response.data.message == "duplicate_name" ? "duplicate_name_status" : err.response.data.message}`)
        })
      }).finally(()=>{
        vm.loading = false
      })
    },
    onPutUserStatus(){
      const vm = this
      vm.loading = true
      const url = `${config.serverUrl}page/${vm.$store.state.selectedBot.pageid}/user-status-list/${vm.dataStatus.id}`
      axios.put(url,{"name": vm.dataStatus.name })
      .then((res)=>{
        if (res.status==200) {
          vm.pageNumber = 1
          vm.getUserStatus()
          vm.dataStatus={id:'',name:''}
          vm.openModal = false
          vm.$swal.fire({
            type: 'success',
            title: vm.$t('Success'),
            text: vm.$t('edit_status_success')
          })
        }
      }).catch((err) => {
        console.error(err);
        vm.$swal.fire({
          type: 'error',
          title: vm.$t('Error'),
          text: vm.$t(`${err.response.data.message == "duplicate_name" ? "duplicate_name_status" : err.response.data.message}`)
        })
      }).finally(()=>{
        vm.loading = false
      })
    },
    async onDelete(id) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        let index = this.items.findIndex(el => el.id == id)
        if (index != -1) {
          let response = await api.deleteUserStatusList({
            body: {
              id: id,
              status: this.items[index].name
            }
          })
          if (response.success) {
            this.$swal.fire({
              type: 'success',
              title: this.$t('Success')
            })
            this.items.splice(index, 1)
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$t('Error')
            })
          }
        }
      }
    },
    onEdit(val) {
      const vm = this
      vm.dataStatus = { id:val.id, name:val.name }
      vm.openModal = !vm.openModal
    }
  },
  watch:{
    openModal:function(newVal){
      if (!newVal) { this.dataStatus = {id:'',name:''} }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/analytics/StatusManagement.vue